var _a;

import { __assign, __awaiter, __decorate, __generator } from "tslib";
import { action, makeObservable, observable, observe } from "mobx";
import { bundle, Config } from "@redocly/openapi-core";
import { debounce } from "lodash";
import { IS_BROWSER, MarkerService, RedocNormalizedOptions, ScrollService, SecurityDefs, SpecStore, SECURITY_DEFINITIONS_COMPONENT_NAME, SECURITY_DEFINITIONS_JSX_NAME, SCHEMA_DEFINITION_JSX_NAME, SchemaDefinition, createParsedDocument } from "../redoc-lib";
import { FakeHistoryService, ProHashHistoryService, PushStateHistoryService } from "./history";
import { ProMenu } from "./ProMenu";
import { DeepSearchStore, RemoteSearch, SEARCH_MAX_DEPTH } from "./SearchStore";
import { extendTheme } from "./extendTheme";
import { RedocResponse, PullRight } from "../components/pluggable";
import { MultipleSpecsStore } from "./MultipleSpecsStore";
import { VersionedSpecStore } from "./VersionedSpecStore";
import parseToken from "./check";
import { normalizePath } from "./utils";
import { fromStorage, toStorage, toLocalStorage, fromLocalStorage, setGlobalStore } from "../utils";
import { LayoutVariant } from "./store-types";

var global = "undefined" == typeof window ? {
  __REDOCLY_SEARCH_URL: void 0
} : window,
    NestingGroup = function () {
  function e(e, t, i, o) {
    var n = this;
    Object.defineProperty(this, "id", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "absoluteIdx", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "description", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "type", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "linkable", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "items", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: []
    }), Object.defineProperty(this, "parent", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "externalDocs", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "active", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: !1
    }), Object.defineProperty(this, "expanded", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: !1
    }), Object.defineProperty(this, "depth", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "level", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), makeObservable(this), this.id = "section/" + e, this.type = "nesting-group", this.name = i || "", this.level = 1, this.depth = 1, this.description = "", this.parent = void 0, this.expanded = !1, this.items = t, this.linkable = !!o, t.forEach(function (e) {
      return e.parent = n;
    }), increaseDepthDeep(t);
  }

  return Object.defineProperty(e.prototype, "activate", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value() {
      this.active = !0;
    }
  }), Object.defineProperty(e.prototype, "expand", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value() {
      this.expanded = !0, this.parent && this.parent.expand();
    }
  }), Object.defineProperty(e.prototype, "collapse", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value() {
      this.expanded = !1;
    }
  }), Object.defineProperty(e.prototype, "deactivate", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value() {
      this.active = !1;
    }
  }), __decorate([observable], e.prototype, "active", void 0), __decorate([observable], e.prototype, "expanded", void 0), __decorate([action], e.prototype, "activate", null), __decorate([action], e.prototype, "expand", null), __decorate([action], e.prototype, "collapse", null), __decorate([action], e.prototype, "deactivate", null), e;
}();

export { NestingGroup };

function increaseDepthDeep(e) {
  Array.isArray(e) && e.forEach(function (e) {
    e.depth++, e.parent && "group" === e.parent.type && (e.depth = e.parent.depth), increaseDepthDeep(e.items);
  });
}

var ProStore = function () {
  function e(e, t, i, o) {
    var n = this;
    void 0 === i && (i = {}), void 0 === o && (o = !0), Object.defineProperty(this, "rawOptions", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "options", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "menu", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "definition", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "marker", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: new MarkerService()
    }), Object.defineProperty(this, "scroll", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "disposer", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "search", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "tryItOperation", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "showRightPanel", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: !0
    }), Object.defineProperty(this, "layout", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: LayoutVariant.THREE_PANEL
    }), Object.defineProperty(this, "activeSampleLanguage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "isLoading", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "l", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "activateSampleLanguage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: debounce(function (e) {
        return n.setActiveSampleLanguage(e);
      }, 500)
    }), makeObservable(this), this.initProOptions(i), IS_BROWSER && (this.l = parseToken(i.licenseKey), this.l.then(function (e) {
      e.valid && e.allowed && !e.expired || e.local || (n.menu.items = [], n.menu.flatItems = n.menu.flatItems.slice(0, 1), n.menu.renderItems = []);
    }));
    var r = Array.isArray(e),
        a = e && Array.isArray(e.versions),
        s = this.options.disableSidebar ? new FakeHistoryService(this.options) : "browser" === this.options.routingStrategy ? new PushStateHistoryService(this.options, r || a) : new ProHashHistoryService(this.options, r || a);
    this.definition = r ? new MultipleSpecsStore(e, this.options) : a ? new VersionedSpecStore(e, this.options, s.currentId.split("/")[0]) : new SpecStore(e, t, this.options), i.downloadDefinitionUrl && (this.definition.info.downloadLink = i.downloadDefinitionUrl, this.definition.info.downloadFileName = ""), this.scroll = new ScrollService(this.options), this.options.disableSidebar || ProMenu.updateOnHistory(s.currentId, this.scroll), this.menu = new ProMenu(this.definition, this.scroll, this.options, s), this.menu.initOnHistory(), this.options.disableSearch || this.initSearch(this.options, o), this.disposer = observe(this.menu, "none" === this.options.pagination ? "activeItemIdx" : "activeRenderItemIdx", function (e) {
      setTimeout(function () {
        return n.updateMarkOnMenu(e.newValue);
      });
    }), setGlobalStore(this);
  }

  return Object.defineProperty(e.prototype, "initProOptions", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value(e) {
      var t, i, o, n, r;
      e = deepClone(e), this.rawOptions = extendTheme(e), this.options = new RedocNormalizedOptions(this.rawOptions, DEFAULT_OPTIONS), this.options.showConsole = null === (t = this.rawOptions.showConsole) || void 0 === t || t, this.options.hideRightPanel = null !== (i = this.rawOptions.hideRightPanel) && void 0 !== i && i, this.showRightPanel = !this.options.hideRightPanel, this.options.showRightPanelToggle = null === (o = this.rawOptions.showRightPanelToggle) || void 0 === o || o, this.options.showChangeLayoutButton = null === (n = this.rawOptions.showChangeLayoutButton) || void 0 === n || n, this.options.layout = this.rawOptions.layout || LayoutVariant.THREE_PANEL, this.options.defaultSampleLanguage = this.rawOptions.defaultSampleLanguage || "", this.options.deepLinkSeparator = this.rawOptions.deepLinkSeparator || "/", this.options.deepLinkPrefix = this.rawOptions.deepLinkPrefix || "!", this.options.disableDeepLinks = this.rawOptions.disableDeepLinks || !1, this.options.sideNavStyle = this.rawOptions.sideNavStyle || "summary-only", this.options.whiteLabel = !!this.rawOptions.whiteLabel, this.options.hideLogo = !!this.rawOptions.hideLogo, this.options.hideInfoSection = !!this.rawOptions.hideInfoSection, this.options.oAuth2RedirectURI = this.rawOptions.oAuth2RedirectURI || null, this.options.oAuth2RedirectURI = this.rawOptions.oAuth2RedirectURI || null, this.options.events = this.rawOptions.events || {}, this.options.corsProxyUrl = this.rawOptions.corsProxyUrl ? addTrailingSlash(this.rawOptions.corsProxyUrl) : null, this.options.authCorsProxyUrl = this.rawOptions.authCorsProxyUrl ? addTrailingSlash(this.rawOptions.authCorsProxyUrl) : null, this.options.theme.scrollYOffset = this.options.scrollYOffset, this.options.linkForId = this.rawOptions.linkForId || null, this.options.generateDeepLink = this.rawOptions.generateDeepLink || null, this.options.onDeepLinkClick = this.rawOptions.onDeepLinkClick || null, this.options.requestInterceptor = this.rawOptions.requestInterceptor || null, this.options.sidebarLinks = this.rawOptions.sidebarLinks || {};
      var a = "object" == typeof this.rawOptions.layout ? this.rawOptions.layout : null;
      if (this.options.pagination = this.rawOptions.pagination || "none", this.options.routingStrategy = "none" === this.options.pagination ? "hash" : "browser", !(null === (r = this.rawOptions) || void 0 === r ? void 0 : r.pagination) && (null == a ? void 0 : a.scope)) switch (console.warn('"layout.scope" and "routingStrategy" settings are deprecated. Please, use "pagination" instead.'), null == a ? void 0 : a.scope) {
        case "all":
          this.options.pagination = "none", this.options.routingStrategy = "hash";
          break;

        case "section":
          this.options.pagination = "section", this.options.routingStrategy = "browser";
          break;

        case "item":
          this.options.pagination = "item", this.options.routingStrategy = "browser";
          break;

        default:
          this.options.pagination = "none", this.options.routingStrategy = "hash";
      }
      this.options.markdownItemsPagination = "none", !1 !== this.rawOptions.showNextButton && (this.options.showNextButton = !0), this.options.disableSidebar = !!e.disableSidebar, this.options.disableSidebar && (this.options.theme.sidebar.width = "0px"), this.options.skipBundleAndConvert = !!e.skipBundleAndConvert, this.options.routingBasePath = e.routingBasePath && normalizePath(e.routingBasePath) || "", this.options.searchAutoExpand = !1 !== e.searchAutoExpand, this.options.searchMode = e.searchMode || "default", this.options.ctrlFHijack = void 0 === e.ctrlFHijack || e.ctrlFHijack, this.options.disablePaginationLoadingAnimation = !!e.disablePaginationLoadingAnimation || "none" === this.options.pagination, this.options.showConsole, this.options.generateCodeSamples = e.generateCodeSamples || {
        languages: []
      }, this.options.searchMaxDepth = this.rawOptions.searchMaxDepth || SEARCH_MAX_DEPTH;
    }
  }), Object.defineProperty(e.prototype, "initSearch", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value(e, t) {
      var i = this;
      global.__REDOCLY_SEARCH_URL ? this.search = new RemoteSearch(global.__REDOCLY_SEARCH_URL) : this.search = new DeepSearchStore(e), t && setTimeout(function () {
        var e;
        return null === (e = i.search) || void 0 === e ? void 0 : e.indexItems(i.menu.items);
      }, 50), this.definition instanceof VersionedSpecStore && observe(this.definition, "activeVersionIdx", function (t) {
        var o,
            n,
            r = i.definition;
        null === (o = i.search) || void 0 === o || o.dispose(), i.search = new DeepSearchStore(e);
        var a = r.versions[t.newValue]._searchIndexName;

        if (IS_BROWSER && a) {
          var s = r.versions[t.newValue]._searchIndexName,
              l = new URL(window.location.href);
          l.pathname = joinURLs(i.options.routingBasePath, s), null === (n = i.search) || void 0 === n || n.fromExternalJS(l.toString(), __redoc_state.searchIndexExport), i.observeAllAndRemark();
        } else setTimeout(function () {
          var e;
          null === (e = i.search) || void 0 === e || e.indexItems(i.menu.items);
        }, 0);
      }), IS_BROWSER && this.observeAllAndRemark();
    }
  }), Object.defineProperty(e.prototype, "onDidMount", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value() {
      if (this.menu.updateOnHistory(), this.updateMarkOnMenu(this.menu.activeItemIdx), this.layout = fromLocalStorage("layoutVariant") || this.options.layout || this.layout, this.activeSampleLanguage = fromLocalStorage("activeSampleLanguage") || this.options.defaultSampleLanguage, this.options.showRightPanelToggle) {
        var e = fromStorage("showRightPanelToggleState");
        e && (this.showRightPanel = "true" === e);
      }
    }
  }), Object.defineProperty(e.prototype, "toggleRightPanel", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value(e) {
      this.showRightPanel = null != e ? e : !this.showRightPanel, toStorage("showRightPanelToggleState", JSON.stringify(this.showRightPanel));
    }
  }), Object.defineProperty(e.prototype, "toggleLayout", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value(e) {
      void 0 === e && (e = LayoutVariant.THREE_PANEL), this.layout = e, toLocalStorage("layoutVariant", e);
    }
  }), Object.defineProperty(e.prototype, "disableConsole", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value() {
      this.options.showConsole = !1;
    }
  }), Object.defineProperty(e.prototype, "enableConsole", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value() {
      this.options.showConsole = !0;
    }
  }), Object.defineProperty(e.prototype, "tryItOut", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value(e) {
      this.tryItOperation = e;
    }
  }), Object.defineProperty(e.prototype, "setActiveSampleLanguage", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value(e) {
      if (this.activeSampleLanguage === e) return this.stopLoader();
      this.activeSampleLanguage = e, toLocalStorage("activeSampleLanguage", e);
    }
  }), Object.defineProperty(e.prototype, "startLoader", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value() {
      this.isLoading || (this.isLoading = !0);
    }
  }), Object.defineProperty(e.prototype, "stopLoader", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value() {
      this.isLoading && (this.isLoading = !1);
    }
  }), Object.defineProperty(e.prototype, "dereferenceSpecForTryIt", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value(e, t) {
      var i, o, n, r;
      return __awaiter(this, void 0, void 0, function () {
        var a, s, l, p, u, c, h;
        return __generator(this, function (d) {
          switch (d.label) {
            case 0:
              return a = void 0 !== e && this.definition.specs ? this.definition.specs[e].parser.definition : this.definition.parser.definition, s = JSON.parse(JSON.stringify(a)), l = __assign(__assign({}, getSpecVersionObj(s)), {
                components: s.components,
                paths: (c = {}, c[t.path] = (h = {}, h[t.httpVerb] = null === (o = null === (i = s.paths) || void 0 === i ? void 0 : i[t.path]) || void 0 === o ? void 0 : o[t.httpVerb], h.parameters = null === (r = null === (n = s.paths) || void 0 === n ? void 0 : n[t.path]) || void 0 === r ? void 0 : r.parameters, h), c)
              }), p = new Config({}), u = createParsedDocument(l), [4, bundle({
                config: p,
                doc: u,
                dereference: !0
              })];

            case 1:
              return d.sent(), [2, s];
          }
        });
      });
    }
  }), Object.defineProperty(e.prototype, "observeAllAndRemark", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value() {
      var e = this,
          t = function t(i) {
        for (var o = 0, n = i; o < n.length; o++) {
          var r = n[o];
          if ("operation" === r.type) for (var a = 0, s = r.responses; a < s.length; a++) {
            var l = s[a];
            observe(l, "expanded", function (t) {
              return e.remark(t);
            });
          } else "tag" === r.type && t(r.items || []);
        }
      };

      t(this.menu.renderItems), "none" !== this.options.pagination && observe(this.menu, "renderItems", function () {
        return t(e.menu.renderItems);
      });
    }
  }), Object.defineProperty(e.prototype, "remark", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value(e) {
      var t = this;
      e.newValue && setTimeout(function () {
        return t.marker.mark();
      }, 0);
    }
  }), Object.defineProperty(e, "fromJS", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value(t) {
      var i,
          o = new e(t.definition.data, t.definition.url, t.options, !1);
      setGlobalStore(o), o.menu.activeItemIdx = void 0 !== t.menu.activeItemIdx ? t.menu.activeItemIdx : -1, o.definition instanceof VersionedSpecStore && t.definition.activeVersionIdx && (o.definition.activeVersionIdx = t.definition.activeVersionIdx || 0);
      var n = o.menu.flatItems[o.menu.activeItemIdx];

      if (n && o.menu.activate(n, !1), !o.options.disableSearch) {
        var r = new URL(window.location.href);
        r.pathname = t.searchIndexPath && t.searchIndexPath.startsWith("/") ? t.searchIndexPath : r.pathname + (r.pathname.endsWith("/") ? "" : "/") + t.searchIndexPath, null === (i = o.search) || void 0 === i || i.fromExternalJS(r.toString(), t.searchIndexExport);
      }

      return t.tryItOperationId && (o.tryItOperation = o.menu.flatItems.find(function (e) {
        return e.id === t.tryItOperationId;
      })), setTimeout(function () {
        return o.observeAllAndRemark();
      }, 0), o;
    }
  }), Object.defineProperty(e.prototype, "toJS", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value() {
      var e;
      return __awaiter(this, void 0, void 0, function () {
        var t, i;
        return __generator(this, function (o) {
          switch (o.label) {
            case 0:
              return i = {
                menu: {
                  activeItemIdx: this.menu.activeItemIdx
                },
                definition: this.definition instanceof MultipleSpecsStore || this.definition instanceof VersionedSpecStore ? {
                  url: void 0,
                  data: this.definition.toJS()
                } : {
                  url: this.definition.parser.definitionUrl,
                  data: this.definition.parser.definition
                }
              }, this.search ? [4, this.search.toJS()] : [3, 2];

            case 1:
              return t = o.sent(), [3, 3];

            case 2:
              t = void 0, o.label = 3;

            case 3:
              return [2, (i.searchIndex = t, i.options = this.rawOptions, i.tryItOperationId = null === (e = this.tryItOperation) || void 0 === e ? void 0 : e.id, i)];
          }
        });
      });
    }
  }), Object.defineProperty(e.prototype, "dispose", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value() {
      this.scroll.dispose(), this.menu.dispose(), this.search && this.search.dispose(), this.disposer();
    }
  }), Object.defineProperty(e.prototype, "updateMarkOnMenu", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value(e) {
      for (var t, i = Math.max(0, e), o = Math.min(this.menu.flatItems.length, i + 5), n = [], r = i; r < o; r++) {
        var a;
        (a = this.menu.getElementAt(r)) && a && n.push(a);
      }

      "item" === this.options.pagination && this.menu.flatItems[e] && this.menu.flatItems[e].parent && (a = this.menu.getElementAt(null === (t = this.menu.flatItems[e].parent) || void 0 === t ? void 0 : t.absoluteIdx)) && n.push(a);
      this.marker.addOnly(n), this.marker.mark();
    }
  }), __decorate([observable], e.prototype, "search", void 0), __decorate([observable], e.prototype, "tryItOperation", void 0), __decorate([observable], e.prototype, "showRightPanel", void 0), __decorate([observable], e.prototype, "layout", void 0), __decorate([observable], e.prototype, "activeSampleLanguage", void 0), __decorate([observable], e.prototype, "isLoading", void 0), __decorate([action], e.prototype, "onDidMount", null), __decorate([action], e.prototype, "toggleRightPanel", null), __decorate([action], e.prototype, "toggleLayout", null), __decorate([action], e.prototype, "disableConsole", null), __decorate([action], e.prototype, "enableConsole", null), __decorate([action], e.prototype, "tryItOut", null), __decorate([action], e.prototype, "setActiveSampleLanguage", null), __decorate([action], e.prototype, "startLoader", null), __decorate([action], e.prototype, "stopLoader", null), e;
}();

export { ProStore };
var DEFAULT_OPTIONS = {
  ignoreNamedSchemas: ["java.io.ObjectStreamField"],
  allowedMdComponents: (_a = {
    RedocResponse: {
      component: RedocResponse,
      propsSelector: function propsSelector(e) {
        return {
          store: e
        };
      }
    },
    PullRight: {
      component: PullRight,
      propsSelector: function propsSelector() {
        return {};
      }
    }
  }, _a[SECURITY_DEFINITIONS_COMPONENT_NAME] = {
    component: SecurityDefs,
    propsSelector: function propsSelector(e) {
      return {
        securitySchemes: e.definition.securitySchemes
      };
    }
  }, _a[SECURITY_DEFINITIONS_JSX_NAME] = {
    component: SecurityDefs,
    propsSelector: function propsSelector(e) {
      return {
        securitySchemes: e.definition.securitySchemes
      };
    }
  }, _a[SCHEMA_DEFINITION_JSX_NAME] = {
    component: SchemaDefinition,
    propsSelector: function propsSelector(e) {
      return {
        parser: e.definition.parser,
        options: e.options,
        layout: e.layout,
        showRightPanel: e.showRightPanel
      };
    }
  }, _a)
};

function joinURLs(e, t) {
  return e.endsWith("/") && (e = e.slice(0, -1)), t.startsWith("/") && (t = t.substring(1)), e + "/" + t;
}

function addTrailingSlash(e) {
  return e.endsWith("/") ? e : e + "/";
}

function getSpecVersionObj(e) {
  return e.openapi ? {
    openapi: e.openapi
  } : e.swagger ? {
    swagger: e.swagger
  } : void 0;
}

function deepClone(e) {
  if ("object" != typeof e || null === e) return e;
  var t = Array.isArray(e) ? [] : {};

  for (var i in e) {
    var o = e[i];
    t[i] = deepClone(o);
  }

  return t;
}